var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwSeatbeltIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    className: "hw_icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seat Belt Use") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.2,5.9h1.6a.8.8,0,0,1,.8.8v9.9a.8.8,0,0,1-.8.8H20.2a2.3,2.3,0,0,1-2.3-2.3v-7a2.3,2.3,0,0,1,2.3-2.3Z",
    transform: "translate(-2.3 17.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25,
    y1: 2,
    x2: 19.5,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30,
    y1: 7,
    x2: 24.5,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.7,15.4l-2.8,1.9a.5.5,0,0,1-.6,0l-2.6-2.6a.5.5,0,0,1,0-.6l1.9-2.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.5,
    y1: 14.4,
    x2: 17.6,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.8,16.3h1.5a.4.4,0,0,1,.4.4v6.1a.4.4,0,0,1-.4.4H11.8a1,1,0,0,1-1-1V17.3a1,1,0,0,1,1-1Z",
    transform: "translate(34.9 25) rotate(135)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.5,
    y1: 19.5,
    x2: 2,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 12.5,
    y1: 24.5,
    x2: 7,
    y2: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.5,19.1h-.4l-3.2-3.2a.3.3,0,0,1,0-.4h0a.3.3,0,0,0,0-.4l-.5-.5a2.2,2.2,0,0,0-3.2,0L6.5,17.3a.9.9,0,0,0,0,1.2l7,7a.9.9,0,0,0,1.2,0l2.7-2.7a2.2,2.2,0,0,0,0-3.2l-.5-.5A.3.3,0,0,0,16.5,19.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.7,
    y1: 22.1,
    x2: 5.8,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4.8,
    y1: 25,
    x2: 4.4,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.1,
    y1: 11.1,
    x2: 25,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26,
    y1: 8.3,
    x2: 26.4,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.5,
    y1: 9.6,
    x2: 6.9,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.1,
    y1: 8.5,
    x2: 11.1,
    y2: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.4,
    y1: 12.2,
    x2: 5.1,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.4,
    y1: 23.5,
    x2: 24,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.8,
    y1: 24.6,
    x2: 19.8,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.5,
    y1: 20.9,
    x2: 25.8,
    y2: 20.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwSeatbeltIcon);
export default __webpack_public_path__ + "static/media/hw_seatbelt_icon.6286521723ac1c50c3f2f2f0e5cf8570.svg";
export { ForwardRef as ReactComponent };